interface BadgeProps {
  children: React.ReactNode
  variant?: 'coming-soon' | 'active'
}

export default function Badge({ children, variant = 'coming-soon' }: BadgeProps) {
  const styles = {
    'coming-soon': 'bg-purple-500/15 text-purple-400',
    'active': 'bg-emerald/20 text-emerald',
  }

  return (
    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${styles[variant]}`}>
      {children}
    </span>
  )
}
